module.exports = __webpack_public_path__ + "static/img/1.f831b12.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/7/3/eng/1.png
// module id = u9vu
// module chunks = 0